import React, { useEffect, useState } from 'react';
import { ConfirmDeleteMessage } from '../../extras/toastMessages';
import { ACTION_EDIT, ACTION_DELETE } from '../../extras/actionTypes';
import TableList from '../../layout/TableList';
//Redux
import { useDispatch, useSelector } from 'react-redux';
import { listOfijusAction, editOfijusAction, deleteOfijusAction } from '../../../actions/ofijusActions';
import { MSG_DELETE, MSG_NOT_REVERT_OPERATION } from '../../../constants/messages';
import { Spinner } from 'react-bootstrap';
import AuthoritiesService from '../../../services/AuthoritiesService';
import { OFIJUS_ELIMINAR, OFIJUS_MODIFICAR } from '../../../data/objects';
import QuickFilter from '../../layout/QuickFilter';
//Función principal
const OfijuList = props => {
    const params = {
         sort: 'nombre:asc'
    }
    //Tomo los props
    const { handleOpen, handleClose } = props;
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const ofijusLoading = useSelector( state => state.ofijus.loading );
    const ofijus = useSelector( state => state.ofijus.ofijus );
    const authorities = useSelector(state => state.auth.authorities);
    //Inicializo el state local
    const [ data, setData ] = useState(null);
    //Manejo de la edición
    const handleEdit = item => {
        //Llamo al dispatch de edición
        dispatch( editOfijusAction(item, handleOpen) );
    }
    //Manjo la eliminación
    const handleDelete = item => {
        //Confirmación
        ConfirmDeleteMessage(
            MSG_DELETE,
            MSG_NOT_REVERT_OPERATION,
            () => {
                dispatch( deleteOfijusAction(item) )
            }
        )
    }
    //Inicializo las cabeceras
    const headers = [
        {
            name: 'Nombre',
            width: null,
            style: null,
            field: 'nombre'
        },
        {
            name: 'Email',
            width: null,
            style: null,
            field: 'email',
        },
        {
            name: 'Email Agenda',
            width: null,
            style: null,
            field: 'emailAgenda',
        },
        {
            name: 'Acción',
            width: '10%',
            style: 'text-center',
            actions: [
                {
                    name: ACTION_EDIT,
                    handle: handleEdit,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, OFIJUS_MODIFICAR)
                },
                {
                    name: ACTION_DELETE,
                    handle: handleDelete,
                    granted: authorities && AuthoritiesService.hasPermission(authorities, OFIJUS_ELIMINAR)
                }
            ]
        }
    ];
    //Cargo los datos
    useEffect(() => {
        //Verifico si hay datos
        if(ofijus){
            //Seteo los datos
            setData(ofijus);
        }else{
            //Si no hay datos, debo cargarlo
            dispatch( listOfijusAction(params) );
        }
    }, [ofijus]);
    //Renderizo
    return (
        <div className="row">
            <div className="col-12">
                <div className="card shadow mb-4">
                    <div className="card-header py-3">
                    <h6 className="m-0 font-weight-bold text-primary">Listado</h6>
                    </div>
                    <div className="card-body">
                        <QuickFilter
                            initialData={ofijus}
                            headers={headers}
                            setData={setData}
                        />
                        {
                            ofijusLoading ? (
                                <Spinner animation="border" role="status">
                                    <span className="sr-only">Cargando...</span>
                                </Spinner>
                            ) : null
                        }
                        {
                            data ? (
                                <TableList
                                    prefix="ofiju"
                                    headers={headers}
                                    items={data}
                                    state={{
                                        field: 'activo',
                                        disabledClass: 'table-danger',
                                        disabledValue: 0,
                                        hideActions: true
                                    }}
                                />
                            ) : null
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfijuList;